<!--
 * @Author: your name
 * @Date: 2022-01-25 14:25:20
 * @LastEditTime: 2022-03-11 17:38:12
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \web-pc\src\views\thirdLogin.vue
-->

<template>
    <div></div>
</template>

<script>
 /*   import x2js from 'x2js'*/
    import { axios, thirdLogin, getPermissions } from "../plugin/axios";
    const sysConfig = require('@/config/sysConfig')
    import router from "../plugin/router";
    import userApi from "@/api/home.js";
    const casServerUrl = sysConfig.casServerUrl
    const sysDomain = sysConfig.sysDomain
    const casLoginUrl = `${casServerUrl}/login`
    export default {

        methods: {
            enableCasAuth() {
                //判断是否已经登录 登录过直接到首页
                if (sessionStorage.getItem('token')) {
                    getPermissions('/api/abp/application-configuration')
                        .then(resUser => {
                            userApi
                                .getUserInfo(resUser.currentUser.id)
                                .then(result => {
                                    sessionStorage.setItem('userInfo', JSON.stringify(result.data));
                                    if (!localStorage.getItem('examList')) {
                                        localStorage.setItem('examList', []);
                                    }

                                    this.$router.push('/home');

                                })
                                .catch(err => {
                                    console.warn(err);
                                });
                        })
                        .catch(err => {
                            console.warn(err);
                            this.closeLoading();
                        });
                    return;
                }
                //判断是否第三方跳转过来，cas登录对方系统传递ticket参数
                if (this.isCasCallback()) {
                    const ticket = this.getTicket();
                    //获取ticket参数进行登录
                    this.getAuthInfo(ticket);
                    //this.getAuthInfo(ticket).then(res => {
                    //    debugger
                    //    if (res.success) {
                    //        const user_id = res.username.__text
                    //        localStorage.setItem('name', user_id)
                    //        this.login(user_id)
                    //    } else {
                    //        this.toAuth()
                    //    }
                    //})
                } else {
                    //跳转到cas登录页
                    this.toAuth()
                }
            },
            toAuth() {
                location.href = `${casLoginUrl}?service=${sysDomain}/#/thirdLogin`
            },
            toIndex(path) {
                location.href = sysDomain + '/#/' + path
            },
            getTicket() {
                var reg = new RegExp('(^|&)ticket=([^&]*)(&|$)', 'i')
                var r = window.location.search.substr(1).match(reg)
                if (r != null) return unescape(r[2])
                return null
            },
            getAuthInfo(ticket) {
                let params = {
                    tickticket: ticket,
                    casUrl: casServerUrl,
                    clientUrl: sysDomain
                };
                thirdLogin('/connect/singletoken-cas', params)
                    .then(res => {
                        if (res.error) {
                            this.$error(res.error_description);
                            this.token = res.error_description;
                            //手动登陆
                            this.$router.push('/login');
                        }
                        // this.token = res;
                        sessionStorage.setItem('token', res.access_token);
                        // this.token = '登录成功正在跳转';
                        console.warn('获取token成功');
                        getPermissions('/api/abp/application-configuration')
                            .then(resUser => {
                                userApi
                                    .getUserInfo(resUser.currentUser.id)
                                    .then(result => {
                                        sessionStorage.setItem('userInfo', JSON.stringify(result.data));
                                        if (!localStorage.getItem('examList')) {
                                            localStorage.setItem('examList', []);
                                        }

                                        this.$router.push('/home');

                                    })
                                    .catch(err => {
                                        console.warn(err);
                                    });
                            })
                            .catch(err => {
                                console.warn(err);
                                this.closeLoading();
                            });
                    })
                    .catch(err => {
                        console.warn(err);
                        this.token = err;
                        //return axios.get(`${casServerUrl}/serviceValidate?service=${sysDomain}&ticket=${ticket}`).then(res => {
                        //    debugger
                        //    const x2j = new x2js()
                        //    var info = x2j.xml2js(res.data)
                        //    if (info.serviceResponse.authenticationSuccess) {
                        //        return {
                        //            'success': true,
                        //            'username': info.serviceResponse.authenticationSuccess.user
                        //        }
                        //    } else {
                        //        return {
                        //            'success': false,
                        //            'username': ''
                        //        }
                        //    }
                        //})
                    });


            },
            isCasCallback() {
                const url = window.location.href
                return url.indexOf('/?ticket=') != -1
            },
            logout() {
                location.href = `${casServerUrl}/logout?service=${sysDomain}`
            },
            getUserByUserId(user_id) {
                //return axios.post(`http://[后台服务地址]/user/token?userCode=${user_id}`)
                //返回的结构大概想这样：
                let data = {
                    code: 1,
                    token: 'admin-token'
                }
                return data;

            },
            login(user_id) {
                this.getUserByUserId(user_id)
                    .then(async (response) => {
                        const data = response.data
                        if (data.code === 1) {

                            var token = data.token
                            //axios.defaults.headers.common['token'] = getToken()
                            // const {
                            //   roles
                            // } = await store.dispatch('user/getInfo')
                            //为了方便，直接给予ADMIN权限
                            //let roles = ['ADMIN']
                            //const accessRoutes = store.dispatch('permission/generateRoutes', roles)
                            //router.addRoutes(accessRoutes)
                            router.push({
                                path: "/home",
                            });
                        } else {
                            router.push({
                                path: '/401'
                            })
                        }
                    })
            }
        }, created() {
            this.enableCasAuth();

        }
    }


</script>

<style>
</style>